export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
 }


 export function nomeMes(i) {

    switch (i.toString()) {

        case '1':

            return 'Janeiro'

        break

        case '2':

            return 'Fevereiro'

        break

        case '3':

            return 'Março'

        break

        case '4':

            return 'Abril'

        break

        case '5':

            return 'Maio'

        break

        case '6':

            return 'Junho'

        break

        case '7':

            return 'Julho'

        break

        case '8':

            return 'Agosto'

        break

        case '9':

            return 'Setembro'

        break

        case '10':

            return 'Outubro'

        break

        case '11':

            return 'Novembro'

        break

        case '12':

            return 'Dezembro'

        break

    }

 }


 export function corCertificado(situacao) {


    switch (situacao) {

        case 'Reconhecimento de participação no Ciclo com Dados Verificados':
            return '#efb500'
            break

        case 'Reconhecimento de participação no Ciclo':
            return '#91edd9'
            break
        
        case 'Nenhum reconhecimento':
        case null:
            return '#dfdfeb'
            break

    }

}


 export function cor(situacao) {


    switch (situacao) {

        case null:
            return '#e1f3e6'
            break

        case 'Z':
            return '#f5c6f5'
            break

        case 'I':
            return '#efb500'
            break

        case 'C':
            return '#50c878'
            break

        case 'O':
            return '#91edd9'
            break

        case 'E':
            return '#f2c7cc'
            break

        case 'V':
            return '#dfdfeb'
         



    }

}



export function rotulo(situacao) {

    switch (situacao) {

        case null:
            return 'Não iniciado'
            break

        case 'I':
            return 'Em preenchimento'
            break

        case 'C':
            return 'Preenchido'
            break

        case 'O':
            return 'Corrigido'
            break

        case 'E':
        case 'P':
            return 'Com pendências'
            break

        case 'V':
            return 'Completo'
            break

        case 'Z':
            return 'Verificado'
            break

    }
}


export function corEnviado(situacao) {

    //<Badge style={{  backgroundColor: renderedCellValue == 'Z' ? '#c769c7' : renderedCellValue == 'P' ? '#ffc4ab' : renderedCellValue == 'S' || renderedCellValue == null  ? '#7edeed' : renderedCellValue == 'A' ? '#ebe7b2' : renderedCellValue == 'V' ? '#59d970' : '#003366'  }}>{rotuloEnviado(renderedCellValue)}</Badge>


    switch (situacao) {

        case 'Z':
            return '#f5c6f5'
            break

        case 'P':
            return '#ffc4ab'
            break

        case 'A':
              return '#ebe7b2'
              break

    
        case 'V':
            return '#59d970'
            break

        case 'O':
            return '#91edd9'                
            break

        case 'S':
        case 'C':
        case null:
            return '#7edeed'                
            break

    }

}


export function rotuloEnviado(situacao) {

    switch (situacao) {

        case 'Z':
            return 'Verificado'
            break

        case 'A':
            return 'Em análise'
            break

        case 'P':
            return 'Com pendências'
            break

        case 'V':
            return 'Completo'
            break

        case 'O':
            return 'Corrigido'
            break

        case 'E':
            return 'Com pendências'
            break

        case 'I':
            return 'Em preenchimento'
            break

        case 'S':
        case 'C':
        case null:
            return 'Submeter Desafio'
            break


    }


}



 export function onlyNumberWithDecimal(e) {
    const charCode = e.which ? e.which : e.keyCode;
    //console.log(charCode)
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44) {
      e.preventDefault();
    } else {
      const length = e.target.value.length;
      const index = e.target.value.indexOf(',');
      if (index > 0 && charCode === 44) {
        e.preventDefault();
      }
      if (index > 0) {
        const CharAfterdot = (length + 1) - index;
        if (CharAfterdot > 2) {
          e.preventDefault();
        }
      }
    }
  }


  export function onlyNumberWithTwoDecimalNegative(e) {
    const charCode = e.which ? e.which : e.keyCode;
    //console.log(charCode)
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44 && charCode !== 45) {
      e.preventDefault();
    } else {
      const length = e.target.value.length;
      const index = e.target.value.indexOf(',');
      if (index > 0 && charCode === 44) {
        e.preventDefault();
      }

      /*
      const index2 = e.target.value.indexOf('-');
      if (index2 > 0 && charCode === 45) {
        e.preventDefault();
      }
      */

      if (index > 0) {
        const CharAfterdot = (length + 1) - index;
        if (CharAfterdot > 3) {
          e.preventDefault();
        }
      }
    }
  }


export function onlyNumberWithTwoDecimal(e) {
    const charCode = e.which ? e.which : e.keyCode;
    //console.log(charCode)
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 44) {
      e.preventDefault();
    } else {
      const length = e.target.value.length;
      const index = e.target.value.indexOf(',');
      if (index > 0 && charCode === 44) {
        e.preventDefault();
      }
      if (index > 0) {
        const CharAfterdot = (length + 1) - index;
        if (CharAfterdot > 3) {
          e.preventDefault();
        }
      }
    }
  }





export function removeDuplicates(originalArray, prop) {
    
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
}



export function fmtMoney(n, c, d, t){ 
    var m = (c = Math.abs(c) + 1 ? c : 2, d = d || ",", t = t || ".", 
       /(\d+)(?:(\.\d+)|)/.exec(n + "")), x = m[1].length > 3 ? m[1].length % 3 : 0; 

    return (x ? m[1].substr(0, x) + t : "") + m[1].substr(x).replace(/(\d{3})(?=\d)/g, 
       "$1" + t) + (c ? d + (+m[2] || 0).toFixed(c).substr(2) : ""); 
 }

export function dataTableRender(tabela, coluna, ordem) {


    if (coluna == null) { coluna = 0 }
    if (ordem == null) { ordem = 'desc' }

    if (tabela == null) {

        var tabelaX = '.table-hover'

    } else {

        var tabelaX = '#' + tabela

    }

    //console.log(tabelaX)

    window.$(tabelaX).DataTable({

        "retrieve": true,
        language: {
            "emptyTable": "Nenhum registro encontrado",
            "info": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
            "infoEmpty": "Mostrando 0 até 0 de 0 registros",
            "infoFiltered": "(Filtrados de _MAX_ registros)",
            "infoThousands": ".",
            "loadingRecords": "Carregando...",
            "processing": "Processando...",
            "zeroRecords": "Nenhum registro encontrado",
            "search": "Pesquisar",
            "paginate": {
                "next": "Próximo",
                "previous": "Anterior",
                "first": "Primeiro",
                "last": "Último"
            },
            
            "aria": {
                "sortAscending": ": Ordenar colunas de forma ascendente",
                "sortDescending": ": Ordenar colunas de forma descendente"
            },
            "select": {
                "rows": {
                    "_": "Selecionado %d linhas",
                    "0": "Nenhuma linha selecionada",
                    "1": "Selecionado 1 linha"
                },
                "1": "%d linha selecionada",
                "_": "%d linhas selecionadas",
                "cells": {
                    "1": "1 célula selecionada",
                    "_": "%d células selecionadas"
                },
                "columns": {
                    "1": "1 coluna selecionada",
                    "_": "%d colunas selecionadas"
                },
                "0": "Nenhuma linha selecionada"
            },
            "buttons": {
                "copySuccess": {
                    "1": "Uma linha copiada com sucesso",
                    "_": "%d linhas copiadas com sucesso"
                },
                "collection": "Coleção  <span class=\"ui-button-icon-primary ui-icon ui-icon-triangle-1-s\"><\/span>",
                "colvis": "Visibilidade da Coluna",
                "colvisRestore": "Restaurar Visibilidade",
                "copy": "Copiar",
                "copyKeys": "Pressione ctrl ou u2318 + C para copiar os dados da tabela para a área de transferência do sistema. Para cancelar, clique nesta mensagem ou pressione Esc..",
                "copyTitle": "Copiar para a Área de Transferência",
                "csv": "CSV",
                "excel": "Excel",
                "pageLength": {
                    "-1": "Mostrar todos os registros",
                    "1": "Mostrar 1 registro",
                    "_": "Mostrar %d registros"
                },
                "pdf": "PDF",
                "print": "Imprimir"
            },
            "autoFill": {
                "cancel": "Cancelar",
                "fill": "Preencher todas as células com",
                "fillHorizontal": "Preencher células horizontalmente",
                "fillVertical": "Preencher células verticalmente"
            },
            "lengthMenu": "Exibir _MENU_ registros por página",
            "searchBuilder": {
                "add": "Adicionar Condição",
                "button": {
                    "0": "Construtor de Pesquisa",
                    "_": "Construtor de Pesquisa (%d)"
                },
                "clearAll": "Limpar Tudo",
                "condition": "Condição",
                "conditions": {
                    "date": {
                        "after": "Depois",
                        "before": "Antes",
                        "between": "Entre",
                        "empty": "Vazio",
                        "equals": "Igual",
                        "not": "Não",
                        "notBetween": "Não Entre",
                        "notEmpty": "Não Vazio"
                    },
                    "number": {
                        "between": "Entre",
                        "empty": "Vazio",
                        "equals": "Igual",
                        "gt": "Maior Que",
                        "gte": "Maior ou Igual a",
                        "lt": "Menor Que",
                        "lte": "Menor ou Igual a",
                        "not": "Não",
                        "notBetween": "Não Entre",
                        "notEmpty": "Não Vazio"
                    },
                    "string": {
                        "contains": "Contém",
                        "empty": "Vazio",
                        "endsWith": "Termina Com",
                        "equals": "Igual",
                        "not": "Não",
                        "notEmpty": "Não Vazio",
                        "startsWith": "Começa Com"
                    },
                    "array": {
                        "contains": "Contém",
                        "empty": "Vazio",
                        "equals": "Igual à",
                        "not": "Não",
                        "notEmpty": "Não vazio",
                        "without": "Não possui"
                    }
                },
                "data": "Data",
                "deleteTitle": "Excluir regra de filtragem",
                "logicAnd": "E",
                "logicOr": "Ou",
                "title": {
                    "0": "Construtor de Pesquisa",
                    "_": "Construtor de Pesquisa (%d)"
                },
                "value": "Valor"
            },
            "searchPanes": {
                "clearMessage": "Limpar Tudo",
                "collapse": {
                    "0": "Painéis de Pesquisa",
                    "_": "Painéis de Pesquisa (%d)"
                },
                "count": "{total}",
                "countFiltered": "{shown} ({total})",
                "emptyPanes": "Nenhum Painel de Pesquisa",
                "loadMessage": "Carregando Painéis de Pesquisa...",
                "title": "Filtros Ativos"
            },
            "searchPlaceholder": "",
            "thousands": ".",
            "datetime": {
                "previous": "Anterior",
                "next": "Próximo",
                "hours": "Hora",
                "minutes": "Minuto",
                "seconds": "Segundo",
                "amPm": [
                    "am",
                    "pm"
                ],
                "unknown": "-"
            },
            "editor": {
                "close": "Fechar",
                "create": {
                    "button": "Novo",
                    "submit": "Criar",
                    "title": "Criar novo registro"
                },
                "edit": {
                    "button": "Editar",
                    "submit": "Atualizar",
                    "title": "Editar registro"
                },
                "error": {
                    "system": "Ocorreu um erro no sistema (<a target=\"\\\" rel=\"nofollow\" href=\"\\\">Mais informações<\/a>)."
                },
                "multi": {
                    "noMulti": "Essa entrada pode ser editada individualmente, mas não como parte do grupo",
                    "restore": "Desfazer alterações",
                    "title": "Multiplos valores",
                    "info": "Os itens selecionados contêm valores diferentes para esta entrada. Para editar e definir todos os itens para esta entrada com o mesmo valor, clique ou toque aqui, caso contrário, eles manterão seus valores individuais."
                },
                "remove": {
                    "button": "Remover",
                    "confirm": {
                        "_": "Tem certeza que quer deletar %d linhas?",
                        "1": "Tem certeza que quer deletar 1 linha?"
                    },
                    "submit": "Remover",
                    "title": "Remover registro"
                }
            },
            "decimal": ","
        },
        "retrieve": true,
        "bInfo": false,
        //"paging": false,
        dom: "<'row'<'col-sm-4'l><'col-sm-4 text-center'B><'col-sm-4'f>>tp",
        "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
        "order": [[ coluna, ordem ]],
        buttons: [
            //{extend: 'copy', className: 'btn-sm'},
            {extend: 'csv', title: 'ExampleFile', className: 'btn-sm'},
            {extend: 'excel', title: 'ExampleFile', className: 'btn-sm'},
            {extend: 'pdf', title: 'ExampleFile', className: 'btn-sm'},
            {extend: 'print', className: 'btn-sm'}
        ]
    });

}


export function validaCNPJ(str){
    str = str.replace('.','');
    str = str.replace('.','');
    str = str.replace('.','');
    str = str.replace('-','');
    str = str.replace('/','');
    var cnpj = str;
    var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
    digitos_iguais = 1;
    if (cnpj.length < 14 && cnpj.length < 15)
        return false;
    for (i = 0; i < cnpj.length - 1; i++)
        if (cnpj.charAt(i) != cnpj.charAt(i + 1))
    {
        digitos_iguais = 0;
        break;
    }
    if (!digitos_iguais)
    {
        tamanho = cnpj.length - 2
        numeros = cnpj.substring(0,tamanho);
        digitos = cnpj.substring(tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--)
        {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--)
        {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;
        return true;
    }
    else
        return false;
}


    

export function validaCPF(cpf) {

    var numeros, digitos, soma, i, resultado, digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length < 11)
            return false;
    for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1))
                {
                digitos_iguais = 0;
                break;
                }
    if (!digitos_iguais)
            {
            numeros = cpf.substring(0,9);
            digitos = cpf.substring(9);
            soma = 0;
            for (i = 10; i > 1; i--)
                soma += numeros.charAt(10 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0))
                return false;
            numeros = cpf.substring(0,10);
            soma = 0;
            for (i = 11; i > 1; i--)
                soma += numeros.charAt(11 - i) * i;
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1))
                return false;
            return true;
            }
    else
        return false;

}
    
